import React, { useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LikeShape from "../../images/slider/like.svg";
import liderd12 from "../../images/slider/hero-home.svg";
import AOS from "aos";

const Hero = (props) => {
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 500,
      once: false,
    });
  }, []);
  return (
    <section className="static-hero" id="home">
      <div className="container-fluid">
        <div className="content" data-aos="fade-right">
          <div className="title">
            <div className="icon">
              <img src={LikeShape} alt="Like Icon" fetchpriority="high" />
            </div>
            <span>Jasa Media Social Management</span>
          </div>
          <div className="sub-title">
            <h2>
              <span>Create and Snap</span> <br /> Your Social Media
            </h2>
          </div>
          <p>
            Langkah Anda adalah kunci kesuksesan dalam membawa bisnis ke tingkat
            yang lebih tinggi.
          </p>
          <div className="hero-btn">
            <a
              href={`https://api.whatsapp.com/send?phone=${props.contact.telephone.username}`}
              className="theme-btn"
              target="_blank"
              rel="noreferrer"
              aria-label="Hubungi Untuk Melakukan Pemesanan"
            >
              {" "}
              Hubungi Kami Sekarang<i className="ti-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="image" data-aos="fade-left">
        <img src={liderd12} alt="Hero CreaSnap" fetchpriority="high" />
      </div>
      <div className="shape-1" data-aos="zoom-in">
        <svg width="362" height="481" viewBox="0 0 362 481" fill="none">
          <circle cx="121.5" cy="240.5" r="240.5" fill="url(#paint_505)" />
          <defs>
            <radialGradient
              id="paint_505"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(121.5 240.5) rotate(90) scale(240.5)"
            >
              <stop offset="0" stopColor="#CED0FF" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div>
      <div className="shape-2" data-aos="zoom-in">
        <svg width="593" height="593" viewBox="0 0 593 593" fill="none">
          <circle cx="296.5" cy="296.5" r="296.5" fill="url(#paint0_318)" />
          <defs>
            <radialGradient
              id="paint0_318"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(296.5 296.5) rotate(90) scale(296.5)"
            >
              <stop offset="0" stopColor="#CED0FF" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
